"use client";

import { Field, withDatasourceCheck } from "@sitecore-jss/sitecore-jss-nextjs";
import { useSitecoreContext } from "@sitecore-jss/sitecore-jss-nextjs";
import clsx from "clsx";
import { useSearchParams } from "next/navigation";
import { useEffect, useState } from "react";
import { ComponentProps } from "@repo/sitecore-lib/component-props";
import * as Box from "@repo/ui/box";
import * as Flex from "@repo/ui/flex";
import { TYPOGRAPHY_LABEL2_SENTENCE } from "@/typography-constants";
import { Search as SearchIcon } from "../../../icons";
import { SEARCH_FIELD_LIMIT } from "./constants";
import { useSearch } from "./search-context";
import styles from "./search.module.css";

export type SearchProps = ComponentProps & {
  fields: {
    hintText: Field<string>;
  };
};

const SearchField = (props: SearchProps): JSX.Element => {
  const { sitecoreContext } = useSitecoreContext();
  const isEditing = sitecoreContext?.pageEditing;

  if (!props.fields || !props.fields.hintText.value) {
    if (!isEditing) {
      return <></>;
    }
  }

  const { handleSubmit } = useSearch();
  const [searchInput, setSearchInput] = useState("");

  const searchParams = useSearchParams();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setSearchInput(value);
  };

  useEffect(() => {
    setSearchInput("");
  }, [searchParams]);

  return (
    <Box.Box width="100%" asChild>
      <Flex.Container align={"center"} justify={"space-between"} asChild>
        <div className={styles.searchForm}>
          <label
            id="search-title"
            htmlFor="search-input"
            className={clsx("sr-only", styles.hiddenLabel)}
          >
            Search
          </label>
          <input
            onChange={handleChange}
            aria-required="false"
            autoComplete="off"
            value={searchInput}
            type="text"
            name="search"
            placeholder={props.fields.hintText.value}
            className={clsx(styles.input, TYPOGRAPHY_LABEL2_SENTENCE)}
            maxLength={SEARCH_FIELD_LIMIT}
            onKeyDown={async (e) => {
              if (e.key === "Enter") {
                await handleSubmit(searchInput);
              }
            }}
          />
          <button
            type="button"
            className={styles.submitButton}
            name="Submit search"
            aria-label="Submit search"
            onClick={async () => {
              await handleSubmit(searchInput);
            }}
          >
            <SearchIcon aria-hidden="true" />
          </button>
        </div>
      </Flex.Container>
    </Box.Box>
  );
};

export default withDatasourceCheck()<SearchProps>(SearchField);
